import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import { useTranslation } from 'react-i18next';

export default function SearchInput(props) {
  const { searchClick, iconDirection, keyword, setKeyword } = props;
  const { t, i18n } = useTranslation();

  const searchBookClick = (e) => {
    if (e) e.preventDefault();
    searchClick();
  };
  return (
    <form onSubmit={searchBookClick}>
      <Paper className="search-input-paper">
        {iconDirection === 'left' ? (
          <>
            <IconButton type="submit" aria-label="search" onClick={searchBookClick}>
              <SearchIcon />
            </IconButton>
            <InputBase
              placeholder={t('search.placeholderSearch')}
              inputProps={{ 'aria-label': 'search google maps' }}
              {...props}
              className="search-input"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </>
        ) : (
          <>
            <InputBase
              placeholder={t('search.placeholderSearch')}
              inputProps={{ 'aria-label': 'search google maps' }}
              {...props}
              className="search-input"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <IconButton type="submit" aria-label="search" onClick={searchBookClick}>
              <SearchIcon />
            </IconButton>
          </>
        )}
      </Paper>
    </form>
  );
}
